import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import useClientConfig from "../../common/hooks/clientConfigHook";
import { connectEpcr, disconnectEpcr, useEpcr } from "../../reducers/epcrSlice";
import PropTypes from 'prop-types';
import { buildEpcrTabs } from "./EpcrTabs";
import { EpcrUpdateContext } from "./EpcrContext";
import useWebsocket from "../../common/hooks/websocketHook";
import TabBar from "../../common/components/TabBar";

const Epcr = ({pcrid, type, site, level}) => {
    const clientConfig = useClientConfig();
    const websocket = useWebsocket();
    const { t } = useTranslation();
    const epcr = useEpcr(pcrid);
    const disabled = !!epcr?.finalized;

    const tabs = useMemo(() => {
        return buildEpcrTabs(t, clientConfig).filter(tab => tab.edit === true).map(tab => ({ ...tab, render: () => tab.render(disabled)}));
    }, [t, clientConfig, disabled]);

    useEffect(() => {
        connectEpcr(websocket, pcrid);
        return () => disconnectEpcr(websocket, pcrid);
    }, [websocket, pcrid])

    return (
        <EpcrUpdateContext pcrid={pcrid} site={site} level={level} type={type}>
            <div className="py-3" style={{backgroundColor: '#31A38F', flex:1}}>
                <TabBar buttons={tabs} t={t} style={{ border: 'none' }} barStyle={{ marginLeft: '18px', marginRight: '18px', backgroundColor: 'white', borderRadius: '8px', padding: '8px' }} bodyStyle={{ backgroundColor: 'transparent', padding: 0 }}></TabBar>
            </div>
        </EpcrUpdateContext>
    )
}

Epcr.propTypes = {
    pcrid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    type: PropTypes.string,
    site: PropTypes.string,
    level: PropTypes.string
}

export default Epcr;